export const canEditBranchDefinition = (status: string) =>
	status === 'ACTIVE' || status === 'LOCKED'

export const branchNameError = (
	name: string,
	branches: { id: string; name: string }[],
	branchId: string,
): 'empty' | 'taken' | null => {
	const trimmed = name.trim()
	if (!trimmed) return 'empty'
	const taken = branches.some(
		(item) => item.id !== branchId && item.name.trim() === trimmed,
	)
	return taken ? 'taken' : null
}
